import React from "react";
import { Link } from "react-router-dom";
import Testimonials from "./Testimonialsabout";
import { FaArrowRight } from "react-icons/fa"; // Import FontAwesome arrow
import LotusVisionMission from "../components/VisionMission";


const Aboutus = () => {
  return (

    
<>



 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>

      <div className="container">
        <div className="page-header__content">
          
          <h2 className="page-header__title">About us</h2>

    

        </div>
      </div>

      {/* Decorative Shapes */}
   

    </section>

    <div className="about-four section-space" id="about">
      <div className="container">
        <div className="row gutter-y-40 align-items-center">
          
          {/* Left Image Section */}
          <div className="col-lg-6">
            <div className="about-four__image wow fadeInLeft">
              
              <div className="about-four__image__item">
                <img
                  src="/images/about2.jpg"
                  alt="about"
                />
              </div>

       

              <p className="about-four__image__text">
                12,500 + Customer Worldwide
              </p>
            </div>
          </div>

          {/* Right Content Section */}
          <div className="col-lg-6">
            <div className="about-four__right">

              <div className="sec-title">
                <div className="sec-title__top">
                  <div className="sec-title__shape"></div>
                  <h6 className="sec-title__tagline">
                    ABOUT OUR COMPANY
                  </h6>
                </div>

                <h3 className="sec-title__title">
                  Your first choice for traveling anywhere
                </h3>
              </div>

              <p className="about-four__top__text">
                Lotus Cab is a premium transportation service committed to delivering safe, reliable, and comfortable rides across the city and beyond. Whether you're commuting locally, catching a flight, or planning a weekend getaway, Lotus Cab is here to make your journey smooth and hassle-free.
              </p>

              <ul className="about-four__list list-unstyled">
                <li>
                  <i className="fas fa-check-circle"></i>
 24/7 availability with professional and courteous drivers
                </li>
                <li>
                  <i className="fas fa-check-circle"></i>
 Easy booking via mobile app or website
                </li>
                 <li>
                  <i className="fas fa-check-circle"></i>
 Wide range of vehicles – from economy to luxury
                </li>
                 <li>
                  <i className="fas fa-check-circle"></i>
 Affordable pricing with no hidden charges
                </li>
              </ul>

              <div className="about-four__bottom">

           

              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Decorative Elements */}
    
      <div className="about-four__shape-left">
        <div className="about-four__shape-left__one"></div>
        <div className="about-four__shape-left__two"></div>
      </div>
    </div>








<LotusVisionMission/>






 <section className="download-app-two section-space">
      {/* Background */}
      <div
        className="download-app-two__bg"
        style={{
          backgroundImage: "url(assets/images/shapes/download-app-bg-2-1.jpg)",
        }}
      ></div>

      <div className="container">
        {/* Section Title */}
        <div className="sec-title sec-title--center">
          <div
            className="sec-title__top wow fadeInUp"
            data-wow-duration="1500ms"
            data-wow-delay="150ms"
          >
            <div className="sec-title__shape"></div>
            <h6 className="sec-title__tagline">
              Why Choose Lotus Cab <FaArrowRight style={{ marginLeft: "5px", color: "#f58220" }} />
            </h6>
            <div className="sec-title__shape"></div>
          </div>

          <h3
            className="sec-title__title wow fadeInUp"
            data-wow-duration="1500ms"
            data-wow-delay="200ms"
          >
            Premium Travel Experience You Can Trust
          </h3>
        </div>

        <div className="row gutter-y-40 align-items-center">
          {/* Left Side */}
          <div
            className="col-lg-4 wow fadeInLeft"
            data-wow-duration="1500ms"
            data-wow-delay="150ms"
          >
            <div className="download-app-two__left">
              <div className="download-app-two__item wow fadeInUp">
                <div className="download-app-two__item__icon">
                  <FaArrowRight style={{ color: "#000", marginRight: "10px" }} />
                </div>
                <div className="download-app-two__item__content">
                  <h3 className="download-app-two__item__title">
                    Local & Outstation Services
                  </h3>
                  <p className="download-app-two__item__text text-white">
                    Reliable cab services for Pune, Mumbai, airport transfers, and long-distance outstation travel across Maharashtra and India.
                  </p>
                </div>
              </div>

              <div className="download-app-two__item wow fadeInUp">
                <div className="download-app-two__item__icon">
                  <FaArrowRight style={{ color: "#000", marginRight: "10px" }} />
                </div>
                <div className="download-app-two__item__content">
                  <h3 className="download-app-two__item__title">
                    Clean & Well-Maintained Fleet
                  </h3>
                  <p className="download-app-two__item__text text-white">
                    Our fleet includes Sedan, SUV, Innova Crysta and Tempo Traveller vehicles that are regularly sanitized and maintained.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Center Image */}
          <div className="col-lg-4">
            <div className="download-app-two__image">
              <div
                className="download-app-two__image__inner"
                style={{
                  backgroundImage: "url(assets/images/resources/download-app-2-1.jpg)",
                }}
              ></div>

              <img
                src="/images/about.png"
                alt="Lotus Cab Service"
                className="download-app-two__image__mockup"
              />
            </div>
          </div>

          {/* Right Side */}
          <div
            className="col-lg-4 wow fadeInRight"
            data-wow-duration="1500ms"
            data-wow-delay="150ms"
          >
            <div className="download-app-two__right">
              <div className="download-app-two__item wow fadeInUp">
                <div className="download-app-two__item__icon">
                  <FaArrowRight style={{ color: "#000", marginRight: "10px" }} />
                </div>
                <div className="download-app-two__item__content">
                  <h3 className="download-app-two__item__title">
                    On-Time Pickup Guarantee
                  </h3>
                  <p className="download-app-two__item__text text-white">
                    We value your time. Our drivers ensure punctual pickups and smooth drop-offs without delays.
                  </p>
                </div>
              </div>

              <div className="download-app-two__item wow fadeInUp">
                <div className="download-app-two__item__icon">
                  <FaArrowRight style={{ color: "#000", marginRight: "10px" }} />
                </div>
                <div className="download-app-two__item__content">
                  <h3 className="download-app-two__item__title">
                    Affordable & Transparent Pricing
                  </h3>
                  <p className="download-app-two__item__text text-white">
                    Competitive fares with clear billing. No hidden charges and complete fare transparency for every ride.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <img
        src="assets/images/shapes/download-app-shape-2-1.png"
        alt="shape"
        className="download-app-two__shape"
      />
    </section>

<Testimonials/>
</>
  );
};

export default Aboutus;
